// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__U126T","rightAdornment":"Header_rightAdornment__2yU-d"};